import { render, staticRenderFns } from "./HistoricDataUpload.vue?vue&type=template&id=a10fba40&scoped=true&"
import script from "./HistoricDataUpload.vue?vue&type=script&lang=js&"
export * from "./HistoricDataUpload.vue?vue&type=script&lang=js&"
import style0 from "./HistoricDataUpload.vue?vue&type=style&index=0&id=a10fba40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10fba40",
  null
  
)

export default component.exports